import type { CameraTuning } from '../game/CameraConfig';
import type { Handling } from '../game/Physics';
import type { PodRacerRigTuning } from '../game/Racer';
import type { StyleConfig } from '../render/StyleConfig';
import type { HydratedSceneAssembly } from './types';

export function assemblyToStyleConfig(assembly: HydratedSceneAssembly): StyleConfig {
  const { lighting, postFx, track } = assembly.layers;
  return deepClone({
    master: lighting.master,
    overrides: lighting.overrides,
    dayCycle: lighting.dayCycle,
    artDirection: lighting.artDirection,
    sky: lighting.sky,
    sunRig: lighting.sunRig,
    clouds: track.clouds,
    asphalt: track.asphalt,
    trackGlint: track.trackGlint,
    edgeLines: track.edgeLines,
    kerbs: track.kerbs,
    furniture: track.furniture,
    fog: lighting.fog,
    ground: track.ground,
    sfx: postFx.sfx,
  });
}

export function assemblyToCameraTuning(assembly: HydratedSceneAssembly): CameraTuning {
  return deepClone(assembly.layers.camera.tuning);
}

export function assemblyToHandling(assembly: HydratedSceneAssembly): Handling {
  return deepClone(assembly.layers.handling.config);
}

export function assemblyToRigTuning(assembly: HydratedSceneAssembly): PodRacerRigTuning {
  const { racerMechanics, racerSoftBody, racerRigFx, racerPaint } = assembly.layers;
  return deepClone({
    ...racerMechanics.tuning,
    ...racerSoftBody.tuning,
    ...racerRigFx.tuning,
    ...racerPaint.tuning,
  }) as PodRacerRigTuning;
}

function deepClone<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}
